if (!customElements.get('burns-subscription-message')) {
  customElements.define('burns-subscription-message', class extends HTMLElement {
    connectedCallback() {
      if (this.context || this.closest('quick-add-modal, modal-dialog, .section-featured-product')) return;

      const context = this.closest('product-info');
      const form = this.closest('form[data-type="add-to-cart-form"]');
      if (!context || context.id !== `ProductInfo-${this.dataset.sectionId}` || !form?.closest('product-form')) return;
      if (!form.querySelector('.product-form__buttons')) return;

      this.context = context;
      this.form = form;
      this.text = this.querySelector('.burns-subscription-message__text');
      this.eligibleVariants = new Set(this.dataset.eligibleVariants.split(',').filter(Boolean));
      this.scheduleUpdate = () => {
        clearTimeout(this.updateTimer);
        this.updateTimer = setTimeout(() => this.update(), 0);
      };
      this.onInteraction = (event) => {
        const path = event.composedPath();
        const widget = this.findWidget();
        const input = event.target;
        if ((widget && path.includes(widget)) ||
          ((event.type === 'change' || event.type === 'input') && input.form === this.form &&
            (input.name === 'selling_plan' || input.name === 'id'))) this.scheduleUpdate();
      };
      this.onVariantChange = (event) => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.scheduleUpdate();
      };

      for (const event of ['click', 'change', 'input', 'keyup']) context.addEventListener(event, this.onInteraction, true);
      document.addEventListener('variant-change', this.onVariantChange);

      // Recharge hydrates outside the theme's variant lifecycle. Observe only its local context.
      const relevant = 'recharge-subscription-widget, input[name="selling_plan"], input[name="id"]';
      this.observer = new MutationObserver((records) => {
        if (records.some((record) => [...record.addedNodes, ...record.removedNodes].some((node) =>
          node.nodeType === Node.ELEMENT_NODE && (node.matches(relevant) || node.querySelector(relevant))
        ))) this.scheduleUpdate();
      });
      this.observer.observe(context, { childList: true, subtree: true });
      this.scheduleUpdate();
    }

    findWidget() {
      const widgets = [...this.context.querySelectorAll('recharge-subscription-widget')].filter((widget) =>
        widget.getAttribute('product-id') === this.dataset.productId && widget.closest('product-info') === this.context
      );
      return widgets.length === 1 ? widgets[0] : null;
    }

    update() {
      const widget = this.findWidget();
      const eligible = this.eligibleVariants.has(this.form.querySelector('input[name="id"]')?.value);
      const inputs = this.form.querySelectorAll('input[name="selling_plan"]');
      const ready = widget && eligible && inputs.length === 1;
      this.toggleAttribute('data-pending', Boolean(widget && eligible && inputs.length === 0));
      if (!ready) {
        this.hidden = true;
        return;
      }

      const copy = inputs[0].value ? this.dataset.subscribe : this.dataset.oneTime;
      if (this.text.textContent !== copy) this.text.textContent = copy;
      this.hidden = false;
    }

    disconnectedCallback() {
      if (!this.context) return;
      clearTimeout(this.updateTimer);
      this.observer.disconnect();
      for (const event of ['click', 'change', 'input', 'keyup']) this.context.removeEventListener(event, this.onInteraction, true);
      document.removeEventListener('variant-change', this.onVariantChange);
      this.context = null;
    }
  });
}
